import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  pageTitle: {
    id: 'portal.views.myCohorts.title',
    defaultMessage: 'My Cohorts',
    description: 'My Cohorts page title',
  },
  newCohortButton: {
    id: 'portal.views.myCohorts.newCohortButton',
    defaultMessage: '+ New Cohort',
    description: 'Button that navigates to the Create a Cohort page',
  },
  restrictedMessage: {
    id: 'portal.views.myCohorts.restricted',
    defaultMessage: 'This page is only available to facilitators.',
    description: 'Message shown to non-facilitators who navigate to the My Cohorts page',
  },
  backToCohortsLink: {
    id: 'portal.views.myCohorts.backLink',
    defaultMessage: 'Back to Cohorts',
    description: 'Link back to the Cohorts landing page',
  },
  emptyStateMessage: {
    id: 'portal.views.myCohorts.emptyState',
    defaultMessage: 'You haven’t created any cohorts yet. Start one to invite learners to work through the course together.',
    description: 'Empty state message when the facilitator has no cohorts yet',
  },
  emptyStateCoFacilitatorMessage: {
    id: 'portal.views.myCohorts.emptyStateCoFacilitator',
    defaultMessage: 'You don’t have any cohorts yet. Cohorts you help facilitate will appear here.',
    description: 'Empty state message shown to a co-facilitator (who cannot create cohorts) when they have no visible cohorts',
  },
  loadErrorMessage: {
    id: 'portal.views.myCohorts.loadError',
    defaultMessage: 'We couldn’t load your cohorts. Please try again.',
    description: 'Error state shown when the cohort list request fails (server error or network failure)',
  },
  createdOnLabel: {
    id: 'portal.views.myCohorts.card.createdOn',
    defaultMessage: 'Created {date}',
    description: 'Cohort card created-on date label, {date} is a localized date',
  },
  memberCountLabel: {
    id: 'portal.views.myCohorts.card.memberCount',
    defaultMessage: '{count} {count, plural, one {member} other {members}}',
    description: 'Cohort card member count label; the card styling uppercases it',
  },
  openButton: {
    id: 'portal.views.myCohorts.card.open',
    defaultMessage: 'Open',
    description: 'Button that navigates to a cohort’s detail page',
  },
  loadMoreButton: {
    id: 'portal.views.myCohorts.loadMore',
    defaultMessage: 'Load more',
    description: 'Button that fetches the next page of cohorts',
  },
  coFacilitatorBadge: {
    id: 'portal.views.myCohorts.badge.coFacilitator',
    defaultMessage: 'Co-Facilitator',
    description: 'Badge on a cohort card where the current user is a co-facilitator',
  },
});

export default messages;
